<zelis-card class="mb-4" [stroke]="true" [elevated]="false">
  <div
    class="two-column-card"
    [ngClass]="{
      'full-border': fullBorder,
      'mat-elevation-z2 border-radius-4': dropShadow
    }"
    fxLayout="column"
    fxHide.lt-md
  >
    <div class="card-header-container" fxLayout="row">
      <div class="picture-column">
        <ng-content select=".card-img-container"></ng-content>
      </div>
      <div class="card-title-section" fxFlex data-cy="card-title-section">
        <ng-content select=".card-top-header"></ng-content>
      </div>
    </div>
    <div class="card-columns-section" fxLayout="row">
      <div fxFlex="55%" class="column-left">
        <ng-content select=".card-column-left"></ng-content>
      </div>
      <div fxFlex="45%" class="column-right">
        <ng-content select=".card-column-right"></ng-content>
      </div>
    </div>
    <div
      *ngIf="displayFooter"
      class="card-footer card-columns-section pad top-3x"
    >
      <ng-content select=".card-footer"></ng-content>
    </div>
  </div>

  <!-- mobile version -->
  <div
    class="two-column-card mobile"
    [ngClass]="{
      'full-border': fullBorder,
      'mat-elevation-z2 border-radius-4': dropShadow
    }"
    fxLayout="column"
    fxLayoutAlign="space-between stretch"
    fxLayoutGap="16px"
    fxHide.gt-sm
  >
    <div
      class="mobile-header-container"
      fxLayout="row"
      fxLayoutAlign="space-between center"
      fxLayoutGap="12px"
    >
      <div class="picture-column">
        <ng-content select=".mobile-img-container"></ng-content>
      </div>
      <div fxFlex="calc(100%-88px)">
        <ng-content select=".mobile-card-header"></ng-content>
      </div>
    </div>
    <ng-content select=".mobile-card-main"></ng-content>
  </div>
</zelis-card>
